/*
 * @Author: vyron
 * @Date: 2022-06-29 14:04:30
 * @LastEditTime: 2022-07-18 16:52:30
 * @LastEditors: vyron
 * @Description: 基础服务封装
 * @FilePath: /capability-platform/src/services/index.ts
 */

export * from "./axios"

export * from "./hooks"

export const URL_PREFIX = process.env.APP_ENV === "development1" ? "" : "/tope-parent-parenting-wins"
